<template>
  <div>
    <div v-if="isSuperAdmin">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="otp">Código OTP</label>
            <input
              v-validate="'numeric|required|min:4|max:6'"
              name="otp"
              id="otpSuperAdmin"
              maxlength="6"
              class="form-control"
              placeholder="OTP"
              size="small"
              v-model="otp"
            />
            <small id="otpHelpSuperAdmin" class="form-text text-muted">
              * Son los seis números que te muestra el Google Authenticator.
            </small>
            <small id="otpErrorSuperAdmin" class="form-text text-danger" v-if="errors.has('otp')">
              *{{ errors.first('otp') }}
            </small>
          </div>
        </div>
      </div>
      <div class="row mt-2 justify-content-end text-right">
        <div class="col-md-7">
          <button
            class="btn btn-primary"
            type="button"
            v-if="!sendingSign"
            @click="signAndConfigure"
          >
            Activar Firma
          </button>
          <b-spinner
            v-if="sendingSign"
            small
            variant="primary"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col container-pdf">
          <pdf
            :src="url"
            v-for="i in numPages"
            :key="i"
            :page="i"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="otp">Código OTP</label>
            <input
              v-validate="'numeric|required|min:4|max:6'"
              name="otp"
              id="otp"
              maxlength="6"
              class="form-control"
              placeholder="OTP"
              size="small"
              v-model="otp"
            />
            <small id="otpHelp" class="form-text text-muted">
              * Son los seis números que te muestra el Google Authenticator.
            </small>
            <small id="otpError" class="form-text text-danger" v-if="errors.has('otp')">
              *{{ errors.first('otp') }}
            </small>
          </div>
        </div>
      </div>
      <div class="row mt-2 justify-content-end text-right">
        <div class="3">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="checkConfirmationRead"
              v-model="confirmationRead"
            >
            <label class="custom-control-label" for="checkConfirmationRead">
              HE LEÍDO Y ACEPTO LAS CONDICIONES
            </label>
          </div>
        </div>
        <div class="col-md-7">
          <button
            class="btn btn-primary"
            type="button"
            @click="signAndConfigure"
            :disabled="!confirmationRead"
            v-if="!sendingSign"
          >
            Firmar Responsabilidad
          </button>

          <b-spinner
            v-if="sendingSign"
            small
            variant="primary"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import pdf from 'vue-pdf-signature';

import { configType, proveedor } from '@/febos/global/usuario/components/sign/simple/agile/constants';
import { configureSimpleAndEsign7Sign } from '@/febos/servicios/api/usuarios.api';

export default {
  name: 'ActiveSign',
  components: {
    pdf
  },
  data() {
    return {
      configType,
      numPages: 0,
      confirmationRead: false,
      isSuperAdmin: false,
      sendingSign: false,
      url: '',
      otp: ''
    };
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser',
      'hasPermission'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  mounted() {
    this.isSuperAdmin = this.hasPermission('FEB99');
    this.url = this.configurations.urlResponsavilidad;
    if (this.url) {
      this.loadPdfFile();
    }
  },
  methods: {
    loadPdfFile() {
      const selectedFile = pdf.createLoadingTask(this.url);
      selectedFile.promise.then((pdfUrl) => {
        this.numPages = pdfUrl.numPages;
      });
    },
    async signAndConfigure() {
      if (!this.otp.trim() || this.errors.has('otp')) {
        return;
      }
      try {
        this.sendingSign = true;
        const data = {
          categoria: this.isSuperAdmin ? 'ACTIVAR_S' : 'ACTIVAR_A',
          codigo: this.otp,
          idUsuarioFirma: this.user.id,
          parametros: { archivoFirmar: this.url },
          proveedor,
          tipoFirma: 'firmaSimple'
        };
        await configureSimpleAndEsign7Sign(data);
        this.$bvToast.toast(
          'Firma Creado',
          {
            title: 'Firma',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        this.$emit('activate', {});
      } finally {
        this.sendingSign = false;
      }
    }
  },
  props: {
    configurations: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  }
};
</script>
<style>
.container-pdf {
  max-height: 80vh;
  overflow-y: auto;
}
</style>
